export default __webpack_public_path__ + "static/media/open-telegram.86fe8f60.svg";